export enum FeatureFlags {
  COMPARE_VIEW = "designControlsComparisonView",
  RELATED_RECORDS_TAB = "relatedRecordsTab",
}
